module.exports = __webpack_public_path__ + "static/logo-39216685d1464912a5bd1361146f2ddf.svg";